import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {TestButton} from "../../../../../components/TestButton";
import {IconDropdownDown2} from "../../../../../icons/IconDropdownDown2";
import {UnitedStates2} from "../../../../../icons/UnitedStates2";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const Corporativo = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClickLogin = () => {
    const currentParams = location.search;
    navigate(`/vxlab-landing-corporativo-mobile${currentParams}`);
  };

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_tutorial_easy-corporativo-mobile${currentParams}`);
  };

  return (
      <div className="corporativo">
        {/* {isFocused && <div className="overlay" onClick={toggleFocus}></div>} */}

        <div className="div-16">
          <div className="overlap-23">
            <div className="group-31">
              <div className="rectangle-31" />
            </div>

            <div className="frame-139">
              <div className="frame-140">
                <div className="frame-141" />
              </div>
              <div className="group-33">
                <UnitedStates2 className="united-states-2" />
                <IconDropdownDown2 className="icon-dropdown-down-2" />
              </div>
            </div>

            {/* <div className="panel-status-bar-2">
            <div className="group-34">
              <div className="group-35">
                <div className="battery-2">
                  <div className="overlap-group-25">
                    <div className="capacity-2" />
                  </div>
                  <img className="cap-2" alt="Cap" src="/img/cap.svg" />
                </div>
                <img className="wifi-2" alt="Wifi" src="/img/wifi.svg" />
                <img
                  className="cellular-connection-2"
                  alt="Cellular connection"
                  src="/img/cellular-connection-1.svg"
                />
              </div>
              <div className="time-2">
                <div className="text-wrapper-124">12:30</div>
              </div>
            </div>
          </div> */}
          </div>

          <div className="overlap-24">
            <div className="text-wrapper-125"></div>
            <div className="text-wrapper-125"></div>
            <div className="text-wrapper-125"></div>
          </div>

          {colors.url_logo !== "" ? (
              <img className="inicio-de-sesion-de-2" src={colors.url_logo} />
          ) : (
              <img
                  className="inicio-de-sesion-de-2"
                  src="/img/inicio-de-sesion-de-usuario-1-1.svg"
              />
          )}

          <div className="subtitle-5">Welcome, Mary</div>
          <div className="subtitle-6">Enter your info</div>

          <div className="action-buttons-2">
            <div onClick={handleButtonClickLogin}>
              <TestButton
                  className={"test-button-4 highlighted-button"}
                  disabled="off"
                  endIcon={false}
                  label="Log in by Password"
                  onColor="off"
                  size="large"
                  startIcon={false}
                  textClassName="test-button-5"
                  type="primary"
              />
            </div>
            <div className="test-button-6 highlighted-button">
              {/* <BtnIconFaceId
              className="btn-icon-face-id-3"
              color={colors.primario}
            /> */}
              <div onClick={handleButtonClick}>
                <div className="text-wrapper-126">Sign in</div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
